// Vendors
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import CountUp from 'react-countup';

const EmissionsData = ({ year }) => {
  const [view, setView] = useState('charts');
  const [emissionsData, setEmissionsData] = useState(null);

  useEffect(() => {
    setEmissionsData({ ...window.wlPipAdmin.emissionsData[year] });
  }, [year]);

  if (emissionsData === null) {
    return <p className="u--margin-0">[No emissions data available]</p>;
  }

  const getChartOptions = (formatter, barColor) => {
    return {
      chart: {
        redrawOnParentResize: true,
        height: 350,
        width: '100%',
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        },
        type: 'bar'
      },
      colors: [barColor],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
          borderRadius: 4,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: formatter,
        offsetY: -25,
        style: {
          colors: ['#333'],
          fontSize: '14px',
          fontFamily: 'neo-sans'
        }
      },
      legend: {
        show: false
      },
      yaxis: {
        labels: {
          formatter: formatter,
          show: true,
          style: {
            colors: ['#333'],
            fontFamily: 'neo-sans'
          }
        }
      },
      xaxis: {
        categories: [
          ...Object.keys(emissionsData.percentages).map((label) => {
            let unit = label == 'co2' || label == 'co2e' ? '(1000 lb)' : '(lb)';
            return [label.toUpperCase(), unit];
          })
        ],
        labels: {
          style: {
            colors: '#002f87',
            fontSize: '16px',
            fontFamily: 'neo-sans',
            fontWeight: 700
          }
        }
      },
      tooltip: {
        enabled: false
      }
    };
  };

  const percentagesData = {
    series: [
      {
        data: [...Object.values(emissionsData.percentages)]
      }
    ],
    options: getChartOptions((val) => `${val}%`, '#004aea')
  };

  const savingsData = {
    series: [
      {
        data: [...Object.values(emissionsData.savings)]
      }
    ],
    options: getChartOptions((val) => val, '#002f87')
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '0 20px',
        minHeight: '200px',
        border: '1px solid gray',
        textAlign: 'center',
        color: 'black'
      }}
    >
      <h2 className="u--margin-top-30 u--margin-bottom-10">
        C02 EMISSIONS DATA
      </h2>
      <h4 className="u--margin-top-0 u--margin-bottom-20">
        Total homes in Dataset: {emissionsData.homes}
      </h4>
      <div className="u--margin-top-0 u--margin-bottom-30 u--text-align-center">
        <button
          className={`btn u--margin-5 ${
            view === 'charts' ? 'btn--blue' : 'btn--gray-light btn--outline'
          }`}
          onClick={() => setView('charts')}
        >
          <span className="btn__content">
            <span className="btn__text">Charts</span>
          </span>
        </button>
        <button
          className={`btn u--margin-5 ${
            view === 'tables' ? 'btn--blue' : 'btn--gray-light btn--outline'
          }`}
          onClick={() => setView('tables')}
        >
          <span className="btn__content">
            <span className="btn__text">Data Tables</span>
          </span>
        </button>
      </div>

      {view === 'charts' && (
        <>
          <div>
            <h3 className="u--margin-0">Average % Reductions</h3>
            <ReactApexChart
              options={percentagesData.options}
              series={percentagesData.series}
              type="bar"
              height={350}
            />
          </div>
          <div>
            <h3 className="u--margin-0">Total Emissions Savings</h3>
            <ReactApexChart
              options={savingsData.options}
              series={savingsData.series}
              type="bar"
              height={350}
            />
          </div>
        </>
      )}

      {view === 'tables' && (
        <table className="epat__table epat__table--admin-dash">
          <thead>
            <tr>
              <th></th>
              {Object.keys(emissionsData.percentages).map((label, index) => {
                let unit =
                  label == 'co2' || label == 'co2e' ? '(1000 lb)' : '(lb)';
                return (
                  <th key={index}>
                    {label.toUpperCase()} {unit}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total Emissions Savings</td>
              {Object.entries(emissionsData.savings).map((item, index) => (
                <td key={index}>
                  <CountUp
                    end={item[1]}
                    separator={','}
                    duration={1.5}
                    delay={0.5}
                  />
                </td>
              ))}
            </tr>
            <tr>
              <td>Average % Reduction</td>
              {Object.entries(emissionsData.percentages).map((item, index) => (
                <td key={index}>
                  <CountUp
                    end={item[1]}
                    separator={','}
                    duration={1.5}
                    delay={0.5}
                  />
                  %
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default EmissionsData;
